import { z } from 'zod'

const PHONE_REGEX = /^\d{10}$/
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i
const NAME_REGEX = /^[a-zA-Z0-9\s.'-]+$/

export const personFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name cannot exceed 100 characters')
    .refine((val) => NAME_REGEX.test(val), 'Full Name must be alphanumeric'),
  email: z
    .string()
    .trim()
    .min(1, 'Email is required')
    .transform((val) => val.toLowerCase())
    .refine(
      (val) => EMAIL_REGEX.test(val),
      'Please enter a valid email address',
    ),
  phoneNumber: z
    .string()
    .trim()
    .optional()
    .or(z.literal(''))
    .transform((val) => (val ? val.replace(/[\s-]/g, '') : ''))
    .refine(
      (val) => !val || PHONE_REGEX.test(val),
      'Phone number must be numeric and exactly 10 digits',
    ),
})
